import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import React from "react";
import newRequest from "../../utils/newRequest";
import Review from "../review/Review";
import "./Reviews.scss";
const Reviews = ({ gigId }) => {
  const queryClient = useQueryClient();
  const { isLoading, error, data } = useQuery({
    queryKey: ["reviews"],
    queryFn: () =>
      newRequest.get(`/reviews/${gigId}`).then((res) => {
        return res.data;
      }),
  });
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  const mutation = useMutation({
    mutationFn: (review) => {
      return newRequest.post("/reviews/add", review);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["reviews"]);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const desc = e.target[0].value;
    const star = e.target[1].value;
    mutation.mutate({ gigId, desc, star });
  };

  return (
    <div className="reviews">
      <h2>Reviews</h2>
      {isLoading
        ? "loading"
        : error
        ? "Something went wrong!"
        : data.map((review) => <Review key={review._id} review={review} />)}

      {currentUser === null ||
        (!currentUser?.isSeller && (
          <div className="add">
            <h3>Add a review</h3>
            <form action="" className="addForm" onSubmit={handleSubmit}>
              <input type="text" placeholder="Write your opinion" />
              <select name="" id="">
              <option value="">--Please choose an option--</option>
                <option value={1}>⭐</option>
                <option value={2}>⭐⭐</option>
                <option value={3}>⭐⭐⭐</option>
                <option value={4}>⭐⭐⭐⭐</option>
                <option value={5}>⭐⭐⭐⭐⭐</option>
              </select>
              <button>Send</button>
            </form>
          </div>
        ))}
    </div>
  );
};

export default Reviews;
